module.exports = __webpack_public_path__ + "static/media/captivating.18c224c7.png";